import { render, staticRenderFns } from "./Step5RewardDraw.vue?vue&type=template&id=604e7df0&scoped=true"
import script from "./Step5RewardDraw.vue?vue&type=script&lang=js"
export * from "./Step5RewardDraw.vue?vue&type=script&lang=js"
import style0 from "./Step5RewardDraw.vue?vue&type=style&index=0&id=604e7df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e7df0",
  null
  
)

export default component.exports